/**
 * Return CSS property value
 *
 * @export
 * @returns {string}
 * @param cssProp
 * @param node
 */
export function getPropertyValue(cssProp: string, node?: HTMLElement) {
  if (!cssProp) {
    console.warn('getPropertyValue: no property provided');
    return '0';
  }

  if (typeof window !== 'undefined') {
    const targetNode = node || document.body;
    const style = getComputedStyle(targetNode);
    return style.getPropertyValue(cssProp);
  } else {
    return '0';
  }
}
